// extracted by mini-css-extract-plugin
export default {"welcome":"WelcomeMsg_welcome__gRO5M","title":"WelcomeMsg_title__RrFFU","ofRwanda":"WelcomeMsg_ofRwanda__y59C1","paragraph":"WelcomeMsg_paragraph__LZ3lT"};